import { useMemo } from 'react';
import { useAuth } from '../contexts';
import { Navigate, Outlet } from 'react-router-dom';

const RoleProtectedRoute = ({ allowedRoles, children }: any) => {
  const { user } = useAuth();

  const hasAccess = useMemo(() => {
    const userRoles =
      user?.userPanelRoles
        ?.map(role => {
          return role?.role?.name?.toUpperCase();
        })
        ?.filter(Boolean) || [];

    return allowedRoles.some((role: string) => userRoles.includes(role));
  }, [user, allowedRoles]);

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};
export default RoleProtectedRoute;
